import React from 'react';
import { motion } from 'framer-motion';
import { Card } from '../components/ui/Card';
import { Input } from '../components/ui/Input';
import { Textarea } from '../components/ui/Textarea';
import { Button } from '../components/ui/Button';
import { MapPin, Phone, Mail, Clock, MessageCircle } from 'lucide-react';
export function ContactPage() {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="pt-20 min-h-screen bg-[#faf8f5]" data-id="element-428">
      <div className="bg-[#1e3a5f] text-white py-16" data-id="element-429">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-430">
          <h1 className="text-4xl font-bold mb-4" data-id="element-431">Contact Us</h1>
          <p className="text-gray-300 max-w-2xl mx-auto" data-id="element-432">
            Have questions? We're here to help you on your journey.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-433">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-434">
          {/* Contact Form */}
          <Card className="p-8" data-id="element-435">
            <h2 className="text-2xl font-bold text-[#1e3a5f] mb-6" data-id="element-436">
              Send us a Message
            </h2>
            <form className="space-y-6" data-id="element-437">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-438">
                <Input label="Name" placeholder="Your Name" data-id="element-439" />
                <Input label="Email" type="email" placeholder="your@email.com" data-id="element-440" />
              </div>
              <Input label="Subject" placeholder="How can we help?" data-id="element-441" />
              <Textarea label="Message" rows={5} placeholder="Tell us more about your query..." data-id="element-442" />
              <Button fullWidth size="lg" data-id="element-443">
                Send Message
              </Button>
            </form>
          </Card>

          {/* Contact Info */}
          <div className="space-y-8" data-id="element-444">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-445">
              <Card className="p-6 flex flex-col items-center text-center" data-id="element-446">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-4" data-id="element-447">
                  <Phone className="h-6 w-6 text-blue-600" data-id="element-448" />
                </div>
                <h3 className="font-bold text-[#1e3a5f] mb-2" data-id="element-449">Phone</h3>
                <p className="text-gray-600 text-sm" data-id="element-450">+1 (555) 123-4567</p>
                <p className="text-gray-600 text-sm" data-id="element-451">+1 (555) 987-6543</p>
              </Card>
              <Card className="p-6 flex flex-col items-center text-center" data-id="element-452">
                <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center mb-4" data-id="element-453">
                  <Mail className="h-6 w-6 text-amber-600" data-id="element-454" />
                </div>
                <h3 className="font-bold text-[#1e3a5f] mb-2" data-id="element-455">Email</h3>
                <p className="text-gray-600 text-sm" data-id="element-456">info@studyboard.com</p>
                <p className="text-gray-600 text-sm" data-id="element-457">
                  admissions@studyboard.com
                </p>
              </Card>
            </div>

            <Card className="p-6" data-id="element-458">
              <div className="flex items-start space-x-4 mb-6" data-id="element-459">
                <MapPin className="h-6 w-6 text-[#f59e0b] mt-1" data-id="element-460" />
                <div data-id="element-461">
                  <h3 className="font-bold text-[#1e3a5f] mb-1" data-id="element-462">Our Office</h3>
                  <p className="text-gray-600" data-id="element-463">
                    123 Education Plaza, Academic District
                    <br data-id="element-464" />
                    New York, NY 10001, USA
                  </p>
                </div>
              </div>
              <div className="flex items-start space-x-4" data-id="element-465">
                <Clock className="h-6 w-6 text-[#f59e0b] mt-1" data-id="element-466" />
                <div data-id="element-467">
                  <h3 className="font-bold text-[#1e3a5f] mb-1" data-id="element-468">
                    Office Hours
                  </h3>
                  <p className="text-gray-600" data-id="element-469">Mon - Fri: 9:00 AM - 6:00 PM</p>
                  <p className="text-gray-600" data-id="element-470">Sat: 10:00 AM - 2:00 PM</p>
                </div>
              </div>
            </Card>

            {/* Map Placeholder */}
            <div className="bg-gray-200 rounded-xl h-64 w-full flex items-center justify-center text-gray-500" data-id="element-471">
              <span className="flex items-center" data-id="element-472">
                <MapPin className="h-5 w-5 mr-2" data-id="element-473" /> Map Integration
              </span>
            </div>
          </div>
        </div>
      </div>
    </motion.div>;
}